import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Observable";
import {User} from "../../../model/lib/interfaces/User";
import {ConfigurationProvider} from "../../configuration/configuration";
import {HttpServiceProvider} from "../../http-service/http-service";

@Injectable()
export class UserService {
  constructor(private configurationService: ConfigurationProvider,
              private httpService: HttpServiceProvider) {
  }

  currentUser(): Observable<User> {
    return this.httpService
      .get(this.configurationService.apiUrl() + "user/get")
      .map(data => <User>data.json());
  }

  registerNfcCard(nfcCard: string) {
    return this.httpService
      .post(this.configurationService.apiUrl() + `user/update/nfc?nfcCard=${nfcCard}`, {});
  }
}



// WEBPACK FOOTER //
// ./src/providers/gastroflow-services/user-service/user-service.ts